// extracted by mini-css-extract-plugin
export default {"bodyContainer":"TrainingSeach_bodyContainer__9T2Zk","searchCard":"TrainingSeach_searchCard__MREsY","formItem":"TrainingSeach_formItem__yKusj"};